import "../../Style.css";
import "../../Brand.css";
import React from "react";
import { Box, Stack, Typography, Card, Grid } from "@mui/material";

const ServiceItem = ({
  title,
  duration,
  price,
  selected,
  onToggle,
  service,
}) => {
  return (
    <Card className="card">
      <Stack padding={2} paddingRight="70px" className="py-xs-1">
        <label>
          <Typography component="h3" fontSize="2.2rem" fontWeight="700">
            {title}
          </Typography>
          <Typography fontSize="1.4rem">{duration}</Typography>
          <Typography
            component="h3"
            fontSize="1.6rem"
            fontWeight="700"
            className="mt-2 m-xs-0"
          >
            from {price}
          </Typography>
          {service.addPromotional &&
            service.promotionalMessage && <Stack
              direction="row"
              paddingBottom={2}
              justifyContent="space-between"
              alignItems="center"
              alignContent="center"
            >
              <Typography
                level="h5"
                component="h5"
                fontWeight="600"
                fontSize="1.2rem"
                className="h5 m-0"
                style={{ color: "#DA6C6C" }}
              >
                {
                  service.promotionalMessage
                }
              </Typography>

            </Stack>}
          <Box className="select-service">
            <input type="checkbox" checked={selected} onChange={onToggle} />
          </Box>
        </label>
        {service.collection === "PackageProduct" &&
          service?.packageProductsList.map((packageItem, packInd) => (
            <ul className="package mb-0 w-100" key={packInd}>
              <li className="m-0">
                <h4 className="m-0 py-1">
                  {packageItem.shortDesc}{" "}
                  {(packageItem.onOrderQuantity ?? 0) > 1 && (
                    <span style={{ color: "#4a6684", marginLeft: "1rem" }}>
                      {" "}
                      {`-${packageItem.onOrderQuantity} nos`}
                    </span>
                  )}
                </h4>
              </li>
            </ul>
          ))}
      </Stack>
    </Card>
  );
};
export default ServiceItem;
